const DISMISS_KEY = 'pushBannerDismissed';
const SERVICE_WORKER_TIMEOUT_MS = 10_000;

export const isPushSupported = () =>
  window.location.protocol === 'https:' &&
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  Boolean(import.meta.env.VITE_PUSH_KEY);

export const isPermissionBlocked = () =>
  'Notification' in window && Notification.permission === 'denied';

export const readDismissed = () => {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
};

export const saveDismissed = () => {
  try {
    sessionStorage.setItem(DISMISS_KEY, '1');
  } catch {}
};

export const urlBase64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(window.atob(base64), (char) => char.charCodeAt(0));
};

export const waitForServiceWorker = () =>
  Promise.race([
    navigator.serviceWorker.ready,
    new Promise<never>((_, reject) =>
      window.setTimeout(
        () => reject(new Error('Service worker not ready')),
        SERVICE_WORKER_TIMEOUT_MS,
      ),
    ),
  ]);

export const subscribeToPush = async () => {
  const registration = await waitForServiceWorker();
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(import.meta.env.VITE_PUSH_KEY as string),
  });
  const { endpoint, keys } = subscription.toJSON();
  if (!endpoint || !keys?.auth || !keys.p256dh) throw new Error('Incomplete push subscription');
  return { endpoint, auth: keys.auth, p256dh: keys.p256dh };
};
